import { CommonModule } from "@angular/common";
import { Component, OnInit, Input } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";

export interface Hero {
  img: string;
  title: string;
  description: string;
  learnMoreUrl: string;
  learnMoreText: string;
  contactUrl: string;
  contactText: string;
}

@Component({
  selector: "app-home-slides-static",
  templateUrl: "./home-slides-static.component.html",
  styleUrls: ["./home-slides-static.component.scss"],
  standalone: true,
  imports: [CommonModule, TranslateModule, MatTooltipModule],
})
export class HomeSlidesComponentStatic implements OnInit {
  public hero: Hero = {
    img: "/assets/images/slider/1920x960_slider2.webp",
    title: "GB_Registration_Slide1_Title",
    description: "GB_Registration_Slide1_Description",
    learnMoreText: "GB_Registration_LearnMore",
    learnMoreUrl: "#AboutUs",
    contactText: "GB_Registration_ContactUs",
    contactUrl: "/register",
  };
  // public slides: any[] = [
  //   {
  //     img: "/assets/images/slider/1920x960_slider1.webp",
  //     title: "GB_Registration_Slide1_Title",
  //     description: "GB_Registration_Slide1_Description",
  //     learnMoreText: "GB_Registration_LearnMore",
  //     learnMoreUrl: "#AboutUs",
  //     contactText: "GB_Registration_ContactUs",
  //     contactUrl: "/register",
  //   },
  //   {
  //     img: "/assets/images/slider/1920x960_slider2.webp",
  //     title: "GB_Registration_Slide2_Title",
  //     description: "GB_Registration_Slide2_Description",
  //     learnMoreText: "GB_Registration_LearnMore",
  //     learnMoreUrl: "#AboutUs",
  //     contactText: "GB_Registration_ContactUs",
  //     contactUrl: "/register",
  //   },
  //   {
  //     img: "/assets/images/slider/1920x960_slider3.webp",
  //     title: "GB_Registration_Slide3_Title",
  //     description: "GB_Registration_Slide3_Description",
  //     learnMoreText: "GB_Registration_LearnMore",
  //     learnMoreUrl: "#AboutUs",
  //     contactText: "GB_Registration_ContactUs",
  //     contactUrl: "/register",
  //   },
  // ];

  constructor() {}

  ngOnInit(): void {}

  scrollToSection(sectionId: string) {
    const el = document.querySelector(sectionId);

    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }
}
